import { DisciplineStateTypes, DisciplineActionTypes } from "./Discipline.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DisciplineStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const DisciplineReducer = (
  state: DisciplineStateTypes = INITIAL_STATE,
  action: any
): DisciplineStateTypes => {
  switch (action.type) {
    case DisciplineActionTypes.FETCH_ALL_DISCIPLINE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DisciplineActionTypes.FETCH_ALL_DISCIPLINE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DisciplineActionTypes.FETCH_ALL_DISCIPLINE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DisciplineActionTypes.FETCH_ALL_DISCIPLINE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case DisciplineActionTypes.FETCH_ONE_DISCIPLINE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case DisciplineActionTypes.FETCH_ONE_DISCIPLINE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case DisciplineActionTypes.FETCH_ONE_DISCIPLINE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DisciplineActionTypes.FETCH_ONE_DISCIPLINE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DisciplineReducer;
